import tooltips from './bs-tooltips';

export default function (container = document) {
  tooltips(container);

}
